<template>
  <div>
    <card>
      <div slot="header" class="row align-items-center">
        <div class="col">
          <h5 class="h3 mb-0">Filtros</h5>
          <h6 class="text-uppercase text-muted ls-1 mb-1">
            Configure quais dados deverão ser listados:
          </h6>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3 col-sm-12">
          <anosafra-multiselect
            v-model="selectedAnoSafra"
            label="Ano Safra"
          />
        </div>
        <div class="col-md-3 col-sm-12" v-show="(currentUser.is_manager || currentUser.is_admin)">
          <label class="form-control-label">Gerente Comercial</label>
          <multiselect
            v-model="selectedManager"
            :options="managers"
            :disabled="currentUser.is_manager && !currentUser.is_admin"
            placeholder="Selecione o Gerente Comercial"
            label="name"
            @search-change="getManagers"
          />
        </div>
        <div class="col-md-3 col-sm-12">
          <label class="form-control-label">Vendedor</label>
          <multiselect
            v-model="selectedDriver"
            :options="drivers"
            :disabled="currentUser.is_salesman && !currentUser.is_admin && !currentUser.is_manager"
            placeholder="Selecione o vendedor"
            label="name"
            @search-change="getDrivers"
          />
        </div>
        <div class="col-md-3 col-sm-12">
          <label class="form-control-label">Data</label>
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="-"
            start-placeholder="Data início"
            end-placeholder="Data fim"
            unlink-panels
            prefix-icon="fa fa-calendar"
            value-format="yyyy-MM-dd"
            format="d 'de' MMMM 'de' yyyy"
          >
          </el-date-picker>
        </div>
      </div>
      <div slot="footer" class="row justify-content-end mr-1">
        <base-button type="secondary" class="mr-2 mt-2" @click="clearFilters">Limpar Filtros</base-button>
        <base-button type="secondary" class="mr-2 mt-2" v-loading="loadingPdf" @click="downloadPdf">
          Gerar PDF
        </base-button>
        <base-button type="secondary" class="mr-2 mt-2" v-loading="loadingXlsx" @click="downloadExcel"
          >Gerar Excel</base-button>
        <base-button type="primary" class="mr-2 mt-2" @click="emitFilter" v-loading="loading">
          Gerar Relatório
        </base-button>
      </div>
    </card>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, getCurrentInstance, defineEmits, watch, defineProps } from 'vue';
import store from '@/store';
import axios from "@/backend/axios/index.js";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import AnosafraMultiselect from "@/components/Multiselect/anosafra_multiselect.vue";
import { DatePicker } from "element-ui";

const ElDatePicker = DatePicker
const dateRange = ref([null, null]); 

const startDate = computed(() => dateRange.value[0]);
const endDate = computed(() => dateRange.value[1]);
dateRange.value = ["",""];

const instance = getCurrentInstance();
const currentUser = instance.proxy.$currentUser();

const props = defineProps({
 loading: Boolean,
});

const clearFilters = () => {
  selectedDriver.value  = "",
  selectedManager.value = "",
  dateRange.value       = []
};

const selectedSalesman = ref(null);

const emit = defineEmits()

const emitFilter = () => {
  const anoSafra_id    = selectedAnoSafra.value ? selectedAnoSafra.value.id   : null;
  const driver_name    = selectedDriver.value   ? selectedDriver.value.name   : null;
  const manager_name   = selectedManager.value  ? selectedManager.value.name  : null;
  const start_date     = startDate.value        ? startDate.value             : null;
  const end_date       = endDate.value          ? endDate.value               : null;

  emit('filter', {
    anoSafra_id,
    driver_name,
    manager_name,
    start_date,
    end_date
  });
};

const selectedAnoSafra = ref(null); 

const selectedManager= ref(null);
const managers = ref([]);
const loadingManagers = ref(false);

const getManagers = async (query = null) => {
  loadingManagers.value = true;

  const data = {
    q: { name: query, is_manager: true, status: true },
  };

  if (selectedAnoSafra.value && selectedAnoSafra.value.id) {
    data.q["anosafra_id"] = selectedAnoSafra.value.id;
  }

  try {
    const response = await axios.get("/api/v2/users", { params:  data});
    managers.value = response.data.data || [];
  } catch (error) {
    console.error("[Resports][FuelUsage][Filters][getManagers]", error);
  } finally {
    loadingManagers.value = false;
  }
};

watch(selectedAnoSafra, () => {
  getManagers(); 
});

const selectedDriver = ref(null)
const drivers = ref([]);
const loadingDrivers = ref(false);

const getDrivers = async (query = null) => {
  loadingDrivers.value = true;

  const data = {
    q: { name: query, is_salesman: true, status: true },
  };

  if (selectedManager.value && selectedManager.value.id) {
    data.q["manager_id"] = selectedManager.value.id;
  }
  if (selectedAnoSafra.value && selectedAnoSafra.value.id) {
    data.q["anosafra_id"] = selectedAnoSafra.value.id;
  }
  console.log("coordinated id", selectedManager.value)

  try {
    const response = await axios.get("/api/v2/users",  { params: data });
    drivers.value = response.data.data || [];
  } catch (error) {
    console.error("[Resports][FuelUsage][Filters][getDrivers]", error);
  } finally {
    loadingDrivers.value = false;
  }
};

watch(selectedManager, () => {
  getDrivers(); 
});

const loadingPdf = ref(false);

const downloadPdf = async () =>{
  loadingPdf.value = true;
  try {
    const response = await axios.get("/api/v1/fuel_transactions.pdf", { 
      params: {
        "filter[driver]": selectedDriver.value   ? selectedDriver.value.name   : null || 
                          selectedManager.value  ? selectedManager.value.name  : null,
        "filter[start_date]": dateRange.value ? startDate.value : null,
        "filter[end_date]": dateRange.value ? endDate.value  : null,
      },
      responseType: "arraybuffer"
    })
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.setAttribute(
      "download",
      `kmPorlitro.pdf`
    );
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    console.error(error);
    loadingPdf.value = false;
  } finally {
    loadingPdf.value = false;
  }
};
const loadingXlsx = ref(false);

const downloadExcel = async () =>{
  loadingXlsx.value = true;
  try {
    const response = await axios.get("/api/v1/fuel_transactions.xlsx", { 
      params: {
        "filter[driver]": selectedDriver.value   ? selectedDriver.value.name   : null || 
                          selectedSalesman.value ? selectedSalesman.value.name : null || 
                          selectedManager.value  ? selectedManager.value.name  : null,
        "filter[start_date]": dateRange.value ? startDate.value : null,
        "filter[end_date]": dateRange.value ? endDate.value  : null,
      },
      responseType: "arraybuffer"
    })
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.setAttribute(
      "download",
      `KmPorlitro.xlsx`
    );
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    console.error("[Reports][FuelTransactions][downloadXlsx]", error);

  } finally {
    loadingXlsx.value = false;
  }
};    

onMounted(() => {
  getManagers();
  getDrivers();

  if (currentUser.is_salesman && !currentUser.is_admin) {
    selectedDriver.value = currentUser;
  }
  if (currentUser.is_manager || this.currentUser.has_coordinateds) {
    selectedManager = this.currentUser;
    drivers = getDrivers();
  }
})
</script>